var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.bookingHasNoShortlistedTalent
      ? _c("div", { staticClass: "no-stars" }, [
          _c("p", [
            _vm._v(
              "\n      There are no " +
                _vm._s(_vm.$t("shortlisted stars")) +
                ".\n    "
            ),
          ]),
        ])
      : _c(
          "ul",
          { staticClass: "shortlist shortlist-horizontal shortlist-col-4" },
          _vm._l(_vm.bookingShortlistedTalent, function (user) {
            return _c("booking-search-details-list-item", {
              key: user.id,
              attrs: { user: user },
            })
          }),
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }